module.exports = __webpack_public_path__ + "static/media/delete.8c7397b8.svg";